import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: '',
    message: ''
  });

  const whatsappNumber = '+96871989006';
  const email = 'cleaningbeesservice1@gmail.com';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hello Cleaning Bees,\n\nName: ${formData.name}\nPhone: ${formData.phone}\nService: ${formData.service}\nMessage: ${formData.message}`;
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div id="contact" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-yellow-600 font-semibold text-sm uppercase tracking-wider">Contact Our Cleaning Company</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-3 mb-4">
            <strong>Contact Cleaning Company Oman</strong> – Get <span className="text-yellow-500">Professional Cleaning Services</span> Today
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ready to experience the best <strong>cleaning services Oman</strong>? Contact our <strong>professional cleaning company</strong> for <strong>house cleaning</strong>, <strong>office cleaning</strong>, and <strong>deep cleaning</strong> in Muscat, Seeb, Barka, Sohar
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information – Cleaning Services Oman</h3>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Call Our Cleaning Company</h4>
                    <a href={`tel:${whatsappNumber}`} className="text-gray-600 hover:text-yellow-600 cursor-pointer">
                      +968 71 989 006
                    </a>
                    <p className="text-sm text-gray-500 mt-1">Professional cleaning services Oman</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Email Us</h4>
                    <a href={`mailto:${email}`} className="text-gray-600 hover:text-yellow-600 cursor-pointer break-all">
                      {email}
                    </a>
                    <p className="text-sm text-gray-500 mt-1">Cleaning company Oman inquiries</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">WhatsApp Cleaning Services</h4>
                    <a 
                      href={`https://wa.me/${whatsappNumber}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 hover:text-green-600 cursor-pointer"
                    >
                      Chat with our cleaning company on WhatsApp
                    </a>
                    <p className="text-sm text-gray-500 mt-1">Quick response for cleaning services Oman</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Service Areas in Oman</h4>
                    <p className="text-gray-600">
                      <strong>Professional cleaning services</strong> across all Oman including Muscat, Seeb, Barka, Mabela, Al Hail, Sohar, Salalah, Al Khuwair, Azaiba, Mawaleh, Rustaq, Nakhal, Quriyat, Nizwa
                    </p>
                    <p className="text-sm text-gray-500 mt-1">Cleaning company near me Oman</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 p-8 rounded-xl shadow-lg text-black">
              <h3 className="text-2xl font-bold mb-4">Quick Contact via WhatsApp</h3>
              <p className="mb-6 text-gray-800">
                Get instant responses about our <strong>house cleaning Oman</strong>, <strong>office cleaning</strong>, and <strong>deep cleaning services</strong>. Our cleaning company team is ready to assist you!
              </p>
              <a
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hello Cleaning Bees, I would like to inquire about your professional cleaning services in Oman.')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-black text-yellow-400 px-6 py-3 rounded-lg hover:bg-gray-900 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Message Us Now</span>
              </a>
            </div>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Request Cleaning Services Oman</h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  Your Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none transition-all text-sm"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none transition-all text-sm"
                  placeholder="+968 XX XXX XXX"
                />
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-semibold text-gray-700 mb-2">
                  Cleaning Service Required *
                </label>
                <select
                  id="service"
                  name="service"
                  required
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none transition-all text-sm cursor-pointer"
                >
                  <option value="">Select a cleaning service</option>
                  <option value="House Cleaning Oman">House Cleaning Services</option>
                  <option value="Maid Services Oman">Maid Services</option>
                  <option value="Office Cleaning Oman">Office Cleaning Services</option>
                  <option value="Deep Cleaning Oman">Deep Cleaning Services</option>
                  <option value="Villa Cleaning Oman">Villa Cleaning</option>
                  <option value="Apartment Cleaning Oman">Apartment Cleaning</option>
                  <option value="Commercial Cleaning Oman">Commercial Cleaning</option>
                  <option value="Sofa & Carpet Cleaning">Sofa & Carpet Cleaning</option>
                  <option value="Swimming Pool Cleaning">Swimming Pool Cleaning</option>
                  <option value="Marble & Tile Polishing">Marble & Tile Polishing</option>
                  <option value="Pest Control">Pest Control Services</option>
                  <option value="Other">Other Cleaning Services</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none transition-all resize-none text-sm"
                  placeholder="Tell us about your cleaning needs in Oman..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full flex items-center justify-center space-x-2 bg-green-500 text-white px-6 py-4 rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>Send via WhatsApp</span>
              </button>
            </form>
          </div>
        </div>

        <footer className="mt-20 pt-12 border-t border-gray-200">
          <div className="text-center">
            <p className="text-gray-600 mb-4">
              © 2025 <strong>Cleaning Bees</strong> – Professional <strong>Cleaning Company Oman</strong>. All rights reserved. <strong>House Cleaning</strong>, <strong>Office Cleaning</strong>, <strong>Deep Cleaning Services</strong> in Muscat, Seeb, Barka, Mabela, Al Hail, Sohar, Salalah &amp; All Oman.
            </p>
            <p className="text-sm text-gray-500">
              <strong>Keywords:</strong> cleaning company Oman, cleaning services Oman, professional cleaning services Oman, house cleaning Oman, office cleaning Oman, deep cleaning Oman, commercial cleaning Oman, villa cleaning Oman, apartment cleaning Oman, residential cleaning Oman, affordable cleaning services Oman, cleaning company Muscat, cleaning company Seeb, cleaning company Barka, cleaning company Sohar, cleaning company near me Oman
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}